// @flow
import React, {Component} from 'react';
import {isEmpty} from 'lodash';

import {Content as DestinationMessageContent} from './destinationMessage';
import {GlobalInlineMessage} from './GlobalInlineMessage';

import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';
import type GlobalMessages from '@homeaway/graphql-global-message';

import './SearchBanner.less';

type Props = {
    globalMessages?: GlobalMessages,
    hasResults: boolean,
    urgencyMessage?: DestinationMessage
};

export class SearchBannerContainer extends Component<Props> {
    render() {
        const {globalMessages, hasResults, urgencyMessage} = this.props;

        if (globalMessages && globalMessages.alert) {
            return <GlobalInlineMessage globalMessages={globalMessages} />;
        }

        let isUrgencyMessage =
            !isEmpty(urgencyMessage) &&
            (!isEmpty(urgencyMessage.iconTitleText) ||
                !isEmpty(urgencyMessage.iconText));

        if (isUrgencyMessage && hasResults) {
            return <DestinationMessageContent {...urgencyMessage} />;
        }

        return null;
    }
}

export default SearchBannerContainer;
